import React from 'react';
import { useI18n } from '@/i18n';

const cardGradients = [
  'bg-[linear-gradient(145deg,#eef5eb_0%,#f8fbf4_55%,#e7f1ea_100%)]',
  'bg-[linear-gradient(145deg,#f4f7ea_0%,#fbfcf8_52%,#edf3e4_100%)]',
  'bg-[linear-gradient(145deg,#f8f7e8_0%,#fffdf4_52%,#eff4e6_100%)]',
];

const TeachBenefitsSection: React.FC = () => {
  const { locale } = useI18n();
  const isZh = locale === 'zh-CN';
  const benefits = [
    {
      title: isZh ? '把知识变成收入' : 'Turn Knowledge Into Income',
      description: isZh
        ? '分享你最擅长的科目，把经验转化为更有意义、也更灵活的教学收入。'
        : 'Share the subjects you know best and turn your experience into meaningful, flexible teaching income.',
    },
    {
      title: isZh ? '更多导师机会' : 'Rich Tutor Opportunities',
      description: isZh
        ? '连接马来西亚各地正在寻找可靠导师的家庭，覆盖不同科目与程度。'
        : 'Connect with families across Malaysia who are actively looking for trusted tutors in different subjects and levels.',
    },
    {
      title: isZh ? '尊重导师的平台' : 'A Platform That Respects Tutors',
      description: isZh
        ? '挑选适合你的个案，清楚展示你的优势，并在支持下建立自己的教学路径。'
        : 'Choose the cases that fit you, present your strengths clearly, and build your tutoring path with support.',
    },
  ];

  return (
    <section className="bg-white py-12 md:py-16">
      <div className="container mx-auto max-w-7xl px-4 md:px-8 lg:px-8 xl:px-10">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {benefits.map((benefit, index) => (
            <article
              key={benefit.title}
              className={`flex min-h-[240px] flex-col rounded-[2rem] px-7 py-7 shadow-sm transition-transform duration-300 hover:-translate-y-1 md:min-h-[300px] md:px-8 ${cardGradients[index]}`}
            >
              <h2 className="max-w-[12ch] text-[2rem] font-black leading-[0.98] tracking-tight text-black sm:text-[2.25rem] md:text-[2.55rem]">
                {benefit.title}
              </h2>
              <p className="mt-auto max-w-[24rem] text-base leading-8 text-stone-700 md:text-[1.02rem] md:leading-8">
                {benefit.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeachBenefitsSection;
